module.exports = __webpack_public_path__ + "static/img/tc01.92b67af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/aug_activity/tc01.png
// module id = 1516
// module chunks = 215